<template>
  <component
    :is="tag"
    :class="classes"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';

export default defineComponent({
  name: 'BaseBlock',
  extends: BaseComponent,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    customClass: {
      type: String,
      default: 'base-block',
    },
  },
});
</script>
